import { useState, useEffect } from 'react'

import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  horizontalListSortingStrategy,
  useSortable,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

//import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

// 1. We extract the Item component to use the hook
function SortableItem({ id, item, index, Inner, innerParams }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    // Start with your basic styles
    cursor: 'grab',
    // Example of adapting your old getItemStyle logic:
    zIndex: isDragging ? 1 : 'auto', 
    opacity: isDragging ? 0.8 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Inner item={item} index={index} params={innerParams} />
    </div>
  );
}

export default function DNDList(props) {
  const { items, reorder, direction, Inner, innerParams } = props;

  // 2. Setup Sensors (this replaces the standard mouse/touch listeners)
  // We use PointerSensor so it works on mobile and desktop automatically
  const sensors = useSensors(
    useSensor(PointerSensor, {
        // Require a move of 8px before drag starts (prevents accidental clicks)
        activationConstraint: { distance: 8 } 
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  // 3. Handle the drag end logic
  function handleDragEnd(event) {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = items.findIndex((item) => item.id === active.id);
      const newIndex = items.findIndex((item) => item.id === over.id);

      // Call your existing reorder function
      reorder(items, oldIndex, newIndex);
    }
  }

  // 4. Determine Layout Direction
  const isVertical = direction === 'vertical';
  
  const listStyle = {
    display: isVertical ? 'block' : 'flex',
    // Add other styles from your old getListStyle here if needed
    flexDirection: isVertical ? 'column' : 'row',
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <div style={listStyle}>
        <SortableContext
          items={items}
          strategy={
            isVertical
              ? verticalListSortingStrategy
              : horizontalListSortingStrategy
          }
        >
          {items.map((item, index) => (
            <SortableItem
              key={item.id}
              id={item.id}
              item={item}
              index={index}
              Inner={Inner}
              innerParams={innerParams}
            />
          ))}
        </SortableContext>
      </div>
    </DndContext>
  );
}

/*export const StrictModeDroppable = ({ children, ...props }: DroppableProps) => {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);
  if (!enabled) {
    return null;
  }
  return <Droppable {...props}>{children}</Droppable>;
};

export default function DNDList ( props )
{
    const itemElement = props.itemElement

    const items = props.items 
    const reorder = props.reorder
    const direction = props.direction
    const Inner = props.Inner
    const innerParams = props.innerParams

    const getListStyle = isDraggingOver => { 

        let style = {
        //background: isDraggingOver ? 'lightblue' : 'lightgrey',
        display: 'flex',
        
        //padding: grid,
        //overflow: 'auto',
        }

        if( direction == "vertical" ) 
        {
            delete style['display']
        }

        return style;
    }

    const getItemStyle = (isDragging, draggableStyle) => {

        return ({
        // some basic styles to make the items look a bit nicer
        //userSelect: 'none',
        //margin: `0 ${grid}px 0 0`,

        // change background colour if dragging
        
        //background: isDragging ? 'lightgreen' : 'grey',

        // styles we need to apply on draggables
        ...draggableStyle,
    })
    }

    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        reorder( items, result.source.index, result.destination.index )
    }

    return (
    <DragDropContext onDragEnd={onDragEnd}>
        <StrictModeDroppable droppableId="droppableMisc" direction={direction}>
          {(provided, snapshot) => (
            <div 
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
              {...provided.droppableProps}
            >
              {items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.id} index={index}  >
                  {(provided, snapshot) => (
                    <div 
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}                     
                    >
                      <Inner item={item} index={index} params={innerParams}/>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </StrictModeDroppable>
      </DragDropContext>
    )
}*/

